export { default } from "./TabFranchiseOpportunity";
